import { modifyHref } from "@/components/Shared/HeaderNavTabs/utils"
import {
  findItemByName,
  getMenuItems,
  getPanelTitles,
  getTabDetails,
  transformArray,
  transformBusinessArray,
} from "@/components/DesignSystem/utils/navigationHelper"
import { sanitizeText } from "@/utils/textUtils"
import { extractPromoBanners } from "@/components/DesignSystem/utils/promoBannerhelper"
import { getLanguageMenu } from "../utils/languageMenuHelper"
import { getBrandsArray } from "@/components/DesignSystem/utils/brandSwitcherHelper"
import {
  extractLinks,
  getCartBadgeCTA,
} from "@/components/DesignSystem/utils/utilityHeaderHelper"
import { GLOBAL_HEADER_TEXT } from "@/components/Shared/HeaderNavTabs/analytics/constant"
import { addMavenoidChat, removeMavenoidChat } from "@/utils/helper"


export const mapMainMenuProps = (
  container = {},
  i18n = {},
  lineItems = {},
  textLineItems = {},
  firstName = "",
  isAuth = false,
  logIndata = {},
  logOutdata = {},
  onclicksignIN = () => {},
  onClickCreateAccount = () => {},
  onClickSignOut = () => {},
  favClickHandler = () => {},
  cartCount = 0,
  themeType = "light",
  handleSearchClick = () => {},
  showBackground = false,
  favoritesPage = [],
  favoritesPagePath = "",
  cartLandingPagePath = "",
  path = "",
  setPromoModal = () => {},
  canadaCheck = false,
  transitionDelay = "",
  searchHeader = "Search",
  language = "en",
  isSaveProductToList = false,
  width = 0
) => {
  const titlesArray = getPanelTitles(findItemByName(container, "tabs"))
  const tabsArray = getTabDetails(findItemByName(container, "tabs"))
  const menuItemsArray = getMenuItems(findItemByName(container, "tabs"))
  const logoData = findItemByName(container, "image")
  const {
    languageMenuTitle = "",
    languageMenuDescription = "",
    regions = [],
    currentCountry = "",
    currentLanguage = "",
    secondLanguageCTA = {},
  } = getLanguageMenu(findItemByName(container, "utilitynavheader"), width) ||
  {}

  const formattedResponse = extractPromoBanners(
    container,
    "promo-details",
    setPromoModal
  )
  const brandSwitcherArray = getBrandsArray(
    findItemByName(container, "brand_switcher")
  )

  const loggedInCtaArray = extractLinks(logIndata)
  const loggedOutCtaArray = extractLinks(logOutdata)

  const cartBadgeCTA = getCartBadgeCTA(
    cartLandingPagePath,
    cartCount,
    canadaCheck
  )
  const dataLayerTitle = "find a showroom"

  const findStoreLabel =
    findItemByName(container, "store")?.findStore ?? "Find a Showroom"

      let buttonCTA = null;
      function findButtonCTA(obj) {
        if (!obj || typeof obj !== "object") return null;
        for (const key in obj) {
          if (key === "button_269119861" && obj[key]?.text) {
            return {
              text: obj[key].text,
              href: obj[key].link,
              target: obj[key].ctaNewTab ? "_blank" : undefined,
            };
          }
          if (typeof obj[key] === "object") {
            const found = findButtonCTA(obj[key]);
            if (found) return found;
          }
        }
        return null;
      }
      buttonCTA = findButtonCTA(container);


      let designerTradeCTA = null;
      function findDesignerTradeCTA(obj) {
        if (!obj || typeof obj !== "object") return null;
        for (const key in obj) {
          if (
            key === "button" &&
            obj[key]?.text &&
            obj[key]?.link
          ) {
            return {
              text: obj[key].text,
              href: obj[key].link,
              target: obj[key].ctaNewTab ? "_blank" : undefined,
            };
          }
          if (typeof obj[key] === "object") {
            const found = findDesignerTradeCTA(obj[key]);
            if (found) return found;
          }
        }
        return null;
      }
      designerTradeCTA = findDesignerTradeCTA(container);

  return {
    promoBanner: {
      mod: formattedResponse.length > 0 ? "slate" : "",
      type: formattedResponse.length > 0 ? "promo" : "",
      content: formattedResponse.length > 0 ? formattedResponse : [],
    },
    mainNavigation:
      menuItemsArray?.length > 0
        ? {
            mod: "white",
            brandCTA:
              menuItemsArray?.length > 0
                ? {
                    brand: "Ann Sacks",
                    href: "/",
                    trackingAttributes: {
                      "data-datalayer-id": "kds-element-navigation",
                      "data-datalayer-data": JSON.stringify({
                        clickInternalLinks: logoData?.link ? "true" : "false",
                        eventAction: "header kohler logo",
                        eventName: "header kohler logo",
                        internalLinkName: "header kohler logo",
                        internalLinkPosition: "global header",
                        internalLinkType: "global header:navigation",

                        internalLinkURL:
                          logoData?.link && typeof window !== "undefined"
                            ? `${window.location.origin}${logoData?.link
                                ?.split(
                                  process.env.NEXT_PUBLIC_INTERNALLINKPATH
                                )
                                .join("")
                                .replace(".html", "")}`
                            : "n/a",
                        internalLinkZoneName: "global header",
                      }),
                    },
                  }
                : {},
            showBackground: showBackground,
            menuItems: menuItemsArray.map((item, index) => {
              const tabTitle = titlesArray[index]
              const tabList= tabsArray.find((tab)=>tab.title===tabTitle) || {}

              // Get imageOrientation from AEM JSON
              const imageOrientation = item?.imageOrientation || "landscape";
              return {
                text: tabTitle,
                mod: "white",
                tabList:tabList?.tabs,
                CTALists:
                  item?.navigationMenuType !== "business"
                    ? transformArray(item, titlesArray[index])
                    : transformBusinessArray(item, titlesArray[index]),
                ...(item.firstImagesblock?.firstImageFileReference && {
                  images: [
                    {
                      image: {
                        src:
                          item.firstImagesblock.firstImageFileReference || "",
                        alt: item.firstImagesblock.altText || "",
                        "data-mode": "smartcrop",
                        trackingAttributes: {
                          "data-datalayer-id": "kds-element-navigation",
                          "data-datalayer-data": JSON.stringify({
                            clickInternalLinks: modifyHref(
                              item.firstImagesblock.ctaLink
                            )
                              ? "true"
                              : "false",
                            internalLinkName: `${tabTitle} > ${sanitizeText(
                              item?.firstImagesblock?.firstImageTitle
                            )} > img_${
                              item?.firstImagesblock?.ctaLabel
                            }`.toLowerCase(),
                            internalLinkURL: modifyHref(
                              item.firstImagesblock.ctaLink
                            )
                              ? `${
                                  modifyHref(
                                    item.firstImagesblock.ctaLink
                                  ).indexOf("http") === -1
                                    ? typeof window !== "undefined" &&
                                      window.location.origin
                                    : ""
                                }${modifyHref(item.firstImagesblock.ctaLink)}`
                              : "n/a",
                          }),
                        },
                      },
                      imageOrientation,
                      caption: {
                        text: item.firstImagesblock.firstImageTitle
                          ? sanitizeText(item.firstImagesblock.firstImageTitle)
                          : "",
                      },
                      multiCTA: item.multiCTA.map((elem, index) => ({
                        text: sanitizeText(elem.ctaLabel),
                        href: modifyHref(elem.ctaLink),
                        trackingAttributes: {
                          "data-datalayer-id": "kds-element-navigation",
                          "data-datalayer-data": JSON.stringify({
                            clickInternalLinks: modifyHref(
                              item.firstImagesblock.ctaLink
                            )
                              ? "true"
                              : "false",
                            internalLinkName: `${tabTitle} > ${sanitizeText(
                              elem.ctaLabel
                            )}`?.toLowerCase(),
                            internalLinkURL: modifyHref(elem.ctaLink)
                              ? `${
                                  modifyHref(elem.ctaLink).indexOf("http") ===
                                  -1
                                    ? typeof window !== "undefined" &&
                                      window.location.origin
                                    : ""
                                }${modifyHref(elem.ctaLink)}`
                              : "n/a",
                          }),
                        },
                      })),
                      CTA: item.firstImagesblock.ctaLabel
                        ? {
                            text: item.firstImagesblock.ctaLabel,
                            href: modifyHref(item.firstImagesblock.ctaLink),
                             target: item.firstImagesblock.ctaNewTab ? '_blank' : undefined,
                            trackingAttributes: {
                              "data-datalayer-id": "kds-element-navigation",
                              "data-datalayer-data": JSON.stringify({
                                clickInternalLinks: modifyHref(
                                  item.firstImagesblock.ctaLink
                                )
                                  ? "true"
                                  : "false",
                                internalLinkName: `${tabTitle} > ${sanitizeText(
                                  item?.firstImagesblock?.firstImageTitle
                                )} > img_${
                                  item?.firstImagesblock?.ctaLabel
                                }`.toLowerCase(),
                                internalLinkURL: modifyHref(
                                  item.firstImagesblock.ctaLink
                                )
                                  ? `${
                                      modifyHref(
                                        item.firstImagesblock.ctaLink
                                      ).indexOf("http") === -1
                                        ? typeof window !== "undefined" &&
                                          window.location.origin
                                        : ""
                                    }${modifyHref(
                                      item.firstImagesblock.ctaLink
                                    )}`
                                  : "n/a",
                              }),
                            },
                          }
                        : undefined,
                    },
                    ...(item.secondImagesblock?.secondImageFileReference
                      ? [
                          {
                            image: {
                              src:
                                item.secondImagesblock
                                  .secondImageFileReference || "",
                              alt: item.secondImagesblock.altText || "",
                              "data-mode": "smartcrop",
                              trackingAttributes: {
                                "data-datalayer-id": "kds-element-navigation",
                                "data-datalayer-data": JSON.stringify({
                                  clickInternalLinks: modifyHref(
                                    item.secondImagesblock.ctaLink
                                  )
                                    ? "true"
                                    : "false",
                                  internalLinkName:
                                    `${tabTitle} > ${sanitizeText(
                                      item?.secondImagesblock?.secondImageTitle
                                    )} > img_${
                                      item?.secondImagesblock?.ctaLabel
                                    }`.toLowerCase(),
                                  internalLinkURL: modifyHref(
                                    item.secondImagesblock.ctaLink
                                  )
                                    ? `${
                                        modifyHref(
                                          item.secondImagesblock.ctaLink
                                        ).indexOf("http") === -1
                                          ? typeof window !== "undefined" &&
                                            window.location.origin
                                          : ""
                                      }${modifyHref(
                                        item.secondImagesblock.ctaLink
                                      )}`
                                    : "n/a",
                                }),
                              },
                            },
                            imageOrientation,
                            caption: {
                              text: item.secondImagesblock.secondImageTitle
                                ? sanitizeText(
                                    item.secondImagesblock.secondImageTitle
                                  )
                                : "",
                            },
                            CTA: item.secondImagesblock.ctaLabel
                              ? {
                                  text: item.secondImagesblock.ctaLabel,
                                  href: modifyHref(
                                    item.secondImagesblock.ctaLink
                                  ),
                                  target: item.secondImagesblock.ctaNewTab ? '_blank' : undefined, 
                                  trackingAttributes: {
                                    "data-datalayer-id":
                                      "kds-element-navigation",
                                    "data-datalayer-data": JSON.stringify({
                                      clickInternalLinks: modifyHref(
                                        item.secondImagesblock.ctaLink
                                      )
                                        ? "true"
                                        : "false",
                                      internalLinkName:
                                        `${tabTitle} > ${sanitizeText(
                                          item?.secondImagesblock
                                            ?.secondImageTitle
                                        )} > img_${
                                          item?.secondImagesblock?.ctaLabel
                                        }`.toLowerCase(),
                                      internalLinkURL: modifyHref(
                                        item.secondImagesblock.ctaLink
                                      )
                                        ? `${
                                            modifyHref(
                                              item.secondImagesblock.ctaLink
                                            ).indexOf("http") === -1
                                              ? typeof window !== "undefined" &&
                                                window.location.origin
                                              : ""
                                          }${modifyHref(
                                            item.secondImagesblock.ctaLink
                                          )}`
                                        : "n/a",
                                    }),
                                  },
                                }
                              : undefined,
                          },
                        ]
                      : []),
                  ],
                }),
              }
            }),
            showMenuDelay: parseInt(transitionDelay) || 0,
            menuCTA: { onClick: () => removeMavenoidChat() },
            closeCTA: { onClick: () => addMavenoidChat() },
            variant: "v2.1",
            searchText: menuItemsArray?.length > 0 ? searchHeader : "",
            searchCTA:
              menuItemsArray?.length > 0
                ? {
                    onClick: () => {
                      handleSearchClick()
                    },
                    trackingAttributes: {
                      "data-datalayer-id": "kds-element-navigation",
                      "data-datalayer-data": JSON.stringify({
                        eventAction: "internal search:open",
                        eventName: "internal search:open",
                        eventType: "navigation",
                        eventMsg: "n/a",
                        eventStatus: "n/a",
                        internalLinkName: "open",
                        internalLinkPosition: "global header: internal search",
                        internalLinkType: "internal search:navigation",
                        internalLinkZoneName: "search:search box",
                        internalLinkURL: "n/a",
                        clickInternalLinks: "true",
                      }),
                    },
                  }
                : {},
            buttonCTA,
            designerTradeCTA,
          }
        : undefined,

    utilityBar: {
      mod: "black",
      ...(path === "/checkout"
        ? {}
        : {
            languagePicker: {
              languagePickerCTA: {
                onClick: () => {},
                trackingAttributes: {
                  "data-datalayer-id": "kds-element-navigation",
                  "data-datalayer-data": JSON.stringify({
                    clickInternalLinks: "true",
                    eventAction: "country select",
                    eventName: "country select",
                    eventType: "click",
                    internalLinkName: `${currentCountry.toLowerCase()} - ${currentLanguage.toLowerCase()}`,
                    internalLinkPosition: "global header",
                    internalLinkType: "global header : navigation",
                    internalLinkURL: "n/a",
                    internalLinkZoneName: "home:global header",
                  }),
                },
              },
              location: currentCountry,
              currentLanguage: currentLanguage,
              secondLanguageCTA:
                Object.keys(secondLanguageCTA).length === 0
                  ? undefined
                  : secondLanguageCTA,
            },
            isLoggedIn: isAuth,
            userName: `${firstName}`,
            userCTA: {
              trackingAttributes: {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": !isAuth
                  ? JSON.stringify({
                      clickInternalLinks: "true",
                      eventAction: "sign in start",
                      eventMsg: "n/a",
                      eventName: "sign in start",
                      eventStatus: "n/a",
                      eventType: "global header",
                      internalLinkName: "sign in start",
                      internalLinkPosition: "global header:sign in start",
                      internalLinkType: "global header:navigation",
                      internalLinkURL: "n/a",
                      internalLinkZoneName: "global header",
                    })
                  : JSON.stringify({
                      clickInternalLinks: "true",
                      eventAction: "global header:your kohler account",
                      eventMsg: "n/a",
                      eventName: "global header:your kohler account",
                      eventStatus: "n/a",
                      eventType: "navigation",
                      internalLinkName: "your kohler account",
                      internalLinkPosition: "global header:my account",
                      internalLinkType:
                        "global header: welcome back to your kohler",
                      internalLinkURL: "n/a",
                      internalLinkZoneName: "global header",
                    }),
              },
            },
            userCTAMobile: {
              signInCTA: {
                text: i18n.signIn,
                onClick: () => {
                  onclicksignIN()
                },
                component: "button",
              },
              signUpCTA: {
                text: i18n.createAccount,
                onClick: () => {
                  onClickCreateAccount()
                },
                component: "button",
              },
              accountCTA: {
                text: `${language === "fr" ? "Bonjour" : "Hi"}, ${firstName}`,
                trackingAttributes: {
                  "data-datalayer-id": "kds-element-navigation",
                  "data-datalayer-data": JSON.stringify({
                    clickInternalLinks: "true",
                    eventAction: "global header:your kohler account",
                    eventMsg: "n/a",
                    eventName: "global header:your kohler account",
                    eventStatus: "n/a",
                    eventType: "navigation",
                    internalLinkName: "your kohler account",
                    internalLinkPosition: "global header:my account",
                    internalLinkType:
                      "global header: welcome back to your kohler",
                    internalLinkURL: "n/a",
                    internalLinkZoneName: "global header",
                  }),
                },
              },
            },
            ...(isAuth
              ? {}
              : {
                  utilityLinksMobile: [
                    {
                      text: loggedOutCtaArray[0]?.text || "",
                      href: loggedOutCtaArray[0]?.href || "",
                      component: "a",
                      trackingAttributes: {
                        "data-datalayer-id": "kds-element-navigation",
                        "data-datalayer-data": JSON.stringify({
                          clickInternalLinks: "true",
                          eventAction: `my account:${loggedOutCtaArray[0]?.text?.toLowerCase()}`,
                          eventName: `my account:${loggedOutCtaArray[0]?.text?.toLowerCase()}`,
                          eventMsg: "n/a",
                          eventStatus: "n/a",
                          eventType: "global header",
                          internalLinkName:
                            loggedOutCtaArray[0]?.text?.toLowerCase(),
                          internalLinkPosition: `global header:${loggedOutCtaArray[0]?.text?.toLowerCase()}`,
                          internalLinkType: "global header:navigation",
                          internalLinkURL:
                            loggedOutCtaArray[0]?.href &&
                            typeof window !== "undefined"
                              ? `${
                                  window.location.origin
                                }${loggedOutCtaArray[0]?.href
                                  ?.split(
                                    process.env.NEXT_PUBLIC_INTERNALLINKPATH
                                  )
                                  .join("")
                                  .replace(".html", "")}`
                              : "n/a",
                          internalLinkZoneName: "global header",
                        }),
                      },
                    },
                  ],
                }),
            locationPickerCTA: {
              text: findStoreLabel,
              trackingAttributes: {
                "data-datalayer-id": "kds-element-navigation",
                "data-datalayer-data": JSON.stringify({
                  eventAction: dataLayerTitle,
                  eventMsg: "n/a",
                  eventName: dataLayerTitle,
                  eventStatus: "n/a",
                  eventType: `${GLOBAL_HEADER_TEXT}`,
                  internalLinkName: dataLayerTitle,
                  internalLinkPosition: `${GLOBAL_HEADER_TEXT}:${dataLayerTitle}`,
                  internalLinkType: `${GLOBAL_HEADER_TEXT}:navigation`,
                  internalLinkZoneName: `${GLOBAL_HEADER_TEXT}`,
                  internalLinkURL: "n/a",
                  clickInternalLinks: "true",
                }),
              },
            },
            favoritesCTA: {
              text:
                language === "fr"
                  ? isSaveProductToList
                    ? "Mes Listes"
                    : "Favoris"
                  : isSaveProductToList
                  ? "My List"
                  : "Favorites",
              onClick: e => favClickHandler(e, favoritesPagePath),
              isFilled:
                isAuth &&
                ((lineItems && lineItems.length > 0) || (textLineItems && textLineItems.length > 0) ||
                  (favoritesPage && favoritesPage.length > 0))
                  ? true
                  : false,
              component: "a",
              href: isAuth ? favoritesPagePath : "",
            },
          }),
      cartBadgeCTA: cartBadgeCTA,
      brands:
        path === "/checkout"
          ? [
              {
                text: "KOHLER",
                href: "https://www.kohler.com",
                target: "_blank",
                isActive: "true",
              },
            ]
          : brandSwitcherArray,
    },
    languageMenu: {
      mod: "black",
      heading: {
        text: languageMenuTitle,
      },
      copy: {
        text: sanitizeText(languageMenuDescription),
      },
      currentCounty: currentCountry,
      regions: regions,
    },
    ...(path === "/checkout"
      ? {}
      : {
          loginMenu: {
            mod: "white",
            headingSignIn: {
              text: `${i18n.welcome} ${firstName}!`,
            },
            headingSignOut: {
              text: i18n.title,
            },
            isLoggedIn: isAuth,
            userName: `${firstName}`,
            loggedOutCTAs: [
              {
                text: i18n.signIn,
                onClick: () => {
                  onclicksignIN()
                },
                component: "button",
              },
              {
                text: i18n.createAccount,
                onClick: () => {
                  onClickCreateAccount()
                },
                component: "button",
              },
              {
                text: loggedOutCtaArray[0]?.text || "",
                href: loggedOutCtaArray[0]?.href || "",
                component: "a",
                trackingAttributes: {
                  "data-datalayer-id": "kds-element-navigation",
                  "data-datalayer-data": JSON.stringify({
                    clickInternalLinks: "true",
                    eventAction: `my account:${loggedOutCtaArray[0]?.text?.toLowerCase()}`,
                    eventName: `my account:${loggedOutCtaArray[0]?.text?.toLowerCase()}`,
                    eventMsg: "n/a",
                    eventStatus: "n/a",
                    eventType: "global header",
                    internalLinkName: loggedOutCtaArray[0]?.text?.toLowerCase(),
                    internalLinkPosition: `global header:${loggedOutCtaArray[0]?.text?.toLowerCase()}`,
                    internalLinkType: "global header:navigation",
                    internalLinkURL:
                      loggedOutCtaArray[0]?.href &&
                      typeof window !== "undefined"
                        ? `${window.location.origin}${loggedOutCtaArray[0]?.href
                            ?.split(process.env.NEXT_PUBLIC_INTERNALLINKPATH)
                            .join("")
                            .replace(".html", "")}`
                        : "n/a",
                    internalLinkZoneName: "global header",
                  }),
                },
              },
            ],
            loggedInCTAs: loggedInCtaArray,
            signOutCTA: {
              text: i18n.logout,
              onClick: () => {
                onClickSignOut()
              },
              component: "button",
            },
          },
        }),
  }
}
